 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"adminhome":"adminhome","cart":"cart","checkout":"checkout","checkoutSuccess":"checkoutSuccess","tournamentMatch~tournamentadvancedmatchsetroundsmode~user":"tournamentMatch~tournamentadvancedmatchsetroundsmode~user","tournamentMatch":"tournamentMatch","kalender":"kalender","matchSchedule~user":"matchSchedule~user","matchSchedule":"matchSchedule","orderhistory":"orderhistory","tournaments":"tournaments","clubinfo~clubs~competitions~editclub~pages~posts":"clubinfo~clubs~competitions~editclub~pages~posts","clubinfo":"clubinfo","clubs~editclub":"clubs~editclub","clubs":"clubs","editclub":"editclub","competitions~members":"competitions~members","competition~competitions":"competition~competitions","competitions":"competitions","pages~posts":"pages~posts","pages":"pages","posts":"posts","clubmembers~edituser~user":"clubmembers~edituser~user","clubmembers":"clubmembers","edituser":"edituser","competitionlist":"competitionlist","members":"members","competition":"competition","domains":"domains","epay":"epay","event":"event","eventlist":"eventlist","events":"events","liveMatchScheduleList":"liveMatchScheduleList","login":"login","mediaArchive":"mediaArchive","menus":"menus","newmember":"newmember","nyheder":"nyheder","nyhedsarkiv":"nyhedsarkiv","products":"products","rankinglist":"rankinglist","rankingmain":"rankingmain","resetPassword":"resetPassword","sponsorlist":"sponsorlist","sponsors":"sponsors","user":"user","tournamentadvancedmatchsetroundsmode":"tournamentadvancedmatchsetroundsmode","users":"users"}[chunkId]||chunkId) + "." + {"adminhome":"fbd8cf87","cart":"53d6fbda","checkout":"122efcf5","checkoutSuccess":"624e042e","chunk-1c2e3c7c":"de8fb312","chunk-1d265d85":"88358788","chunk-219024c8":"16210fef","chunk-3b6ce5e7":"df8e6b44","tournamentMatch~tournamentadvancedmatchsetroundsmode~user":"25c38adb","tournamentMatch":"c90c84ac","chunk-c2ce68cc":"b5ac5acf","kalender":"b213db53","matchSchedule~user":"007a928e","matchSchedule":"80fc8f62","orderhistory":"eeb1db9b","chunk-28f2925b":"edcae27e","chunk-29b3ec5d":"76a659c0","chunk-342b20e8":"e9b7600c","chunk-23ab1979":"c6ec192f","chunk-7be55077":"a5169048","tournaments":"a57a668d","chunk-5d5f2d8f":"7679d7ae","chunk-6abf588b":"d2b96229","chunk-7a9cf88e":"f6601f13","chunk-8c523498":"e5d8877a","chunk-b821f780":"93c39d9c","chunk-f5036d62":"d91d7b11","clubinfo~clubs~competitions~editclub~pages~posts":"816085b1","clubinfo":"e4975025","clubs~editclub":"634157ae","clubs":"0ccde197","editclub":"e0ab3111","competitions~members":"378e3d1d","competition~competitions":"cd6ce383","competitions":"5afb274b","pages~posts":"437fd87d","pages":"9afc4289","posts":"56d88afe","clubmembers~edituser~user":"f1352f24","clubmembers":"bf7cf8be","edituser":"4ee5effa","competitionlist":"182ff6ee","members":"07614622","competition":"05ee0c8a","domains":"bbc24351","epay":"6da2f13a","event":"bf3aaffc","eventlist":"0b6944fd","events":"7fdf1948","liveMatchScheduleList":"9d69a53e","login":"e984aab8","mediaArchive":"abe9a7e4","menus":"21dfac11","newmember":"a1afffcc","nyheder":"d3904b15","nyhedsarkiv":"e9a2578d","products":"e89feb30","rankinglist":"53630e5e","rankingmain":"6a0f400e","resetPassword":"9dbaf92a","sponsorlist":"a937db83","sponsors":"4979890b","user":"4a0cb11e","tournamentadvancedmatchsetroundsmode":"8abab508","users":"eaeb6523"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"adminhome":1,"cart":1,"checkout":1,"checkoutSuccess":1,"chunk-1c2e3c7c":1,"chunk-1d265d85":1,"chunk-219024c8":1,"tournamentMatch~tournamentadvancedmatchsetroundsmode~user":1,"tournamentMatch":1,"chunk-c2ce68cc":1,"kalender":1,"matchSchedule":1,"orderhistory":1,"chunk-28f2925b":1,"chunk-29b3ec5d":1,"chunk-342b20e8":1,"chunk-23ab1979":1,"chunk-7be55077":1,"tournaments":1,"chunk-5d5f2d8f":1,"chunk-6abf588b":1,"chunk-7a9cf88e":1,"chunk-8c523498":1,"chunk-b821f780":1,"chunk-f5036d62":1,"clubinfo~clubs~competitions~editclub~pages~posts":1,"clubinfo":1,"clubs":1,"editclub":1,"competitions":1,"pages~posts":1,"pages":1,"clubmembers":1,"edituser":1,"competitionlist":1,"members":1,"competition":1,"domains":1,"event":1,"eventlist":1,"events":1,"liveMatchScheduleList":1,"login":1,"mediaArchive":1,"menus":1,"newmember":1,"nyheder":1,"nyhedsarkiv":1,"products":1,"rankinglist":1,"rankingmain":1,"resetPassword":1,"sponsorlist":1,"sponsors":1,"user":1,"users":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"adminhome":"adminhome","cart":"cart","checkout":"checkout","checkoutSuccess":"checkoutSuccess","tournamentMatch~tournamentadvancedmatchsetroundsmode~user":"tournamentMatch~tournamentadvancedmatchsetroundsmode~user","tournamentMatch":"tournamentMatch","kalender":"kalender","matchSchedule~user":"matchSchedule~user","matchSchedule":"matchSchedule","orderhistory":"orderhistory","tournaments":"tournaments","clubinfo~clubs~competitions~editclub~pages~posts":"clubinfo~clubs~competitions~editclub~pages~posts","clubinfo":"clubinfo","clubs~editclub":"clubs~editclub","clubs":"clubs","editclub":"editclub","competitions~members":"competitions~members","competition~competitions":"competition~competitions","competitions":"competitions","pages~posts":"pages~posts","pages":"pages","posts":"posts","clubmembers~edituser~user":"clubmembers~edituser~user","clubmembers":"clubmembers","edituser":"edituser","competitionlist":"competitionlist","members":"members","competition":"competition","domains":"domains","epay":"epay","event":"event","eventlist":"eventlist","events":"events","liveMatchScheduleList":"liveMatchScheduleList","login":"login","mediaArchive":"mediaArchive","menus":"menus","newmember":"newmember","nyheder":"nyheder","nyhedsarkiv":"nyhedsarkiv","products":"products","rankinglist":"rankinglist","rankingmain":"rankingmain","resetPassword":"resetPassword","sponsorlist":"sponsorlist","sponsors":"sponsors","user":"user","tournamentadvancedmatchsetroundsmode":"tournamentadvancedmatchsetroundsmode","users":"users"}[chunkId]||chunkId) + "." + {"adminhome":"60a95781","cart":"0b6f698a","checkout":"6836a386","checkoutSuccess":"191d4bdf","chunk-1c2e3c7c":"8dd093ca","chunk-1d265d85":"d72c357f","chunk-219024c8":"492d519d","chunk-3b6ce5e7":"31d6cfe0","tournamentMatch~tournamentadvancedmatchsetroundsmode~user":"8aabf098","tournamentMatch":"af5c8aa5","chunk-c2ce68cc":"03ee8ee4","kalender":"57bca1fc","matchSchedule~user":"31d6cfe0","matchSchedule":"0f32b926","orderhistory":"9e8d433a","chunk-28f2925b":"4cda68d3","chunk-29b3ec5d":"fd83f3d3","chunk-342b20e8":"9aae7b1a","chunk-23ab1979":"a633258f","chunk-7be55077":"6758cb15","tournaments":"dee9d95d","chunk-5d5f2d8f":"89911f79","chunk-6abf588b":"b97fc5dc","chunk-7a9cf88e":"0e433876","chunk-8c523498":"99798fd4","chunk-b821f780":"167b0dfc","chunk-f5036d62":"9c098c70","clubinfo~clubs~competitions~editclub~pages~posts":"b295039b","clubinfo":"e8a5fa5f","clubs~editclub":"31d6cfe0","clubs":"6e64ba03","editclub":"5fc1d8e4","competitions~members":"31d6cfe0","competition~competitions":"31d6cfe0","competitions":"feecaa6a","pages~posts":"b79daa1e","pages":"6c8422c1","posts":"31d6cfe0","clubmembers~edituser~user":"31d6cfe0","clubmembers":"63ec880c","edituser":"d52bb476","competitionlist":"0e17f606","members":"9bb2c734","competition":"6a1faca1","domains":"c491bde4","epay":"31d6cfe0","event":"09b959ef","eventlist":"497164cd","events":"bf28ca9a","liveMatchScheduleList":"ca160fc6","login":"5f6c4147","mediaArchive":"5f0f3a14","menus":"f755a1e7","newmember":"4ae805d6","nyheder":"ed524737","nyhedsarkiv":"437e4eb3","products":"b10a7345","rankinglist":"f2905f89","rankingmain":"0ca72882","resetPassword":"0e433876","sponsorlist":"ddaba1ec","sponsors":"3b03ca45","user":"039ff63e","tournamentadvancedmatchsetroundsmode":"31d6cfe0","users":"55e189bd"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
